/**
 * Created by dx.yang on 2017/3/20.
 */


import {KecPath, Service, Version, source} from './constants';

export const DescribeImages = {
    basePath: KecPath,
    params: {
        Action: 'DescribeImages',
        Service,
        Version,
        source
    }
};

export const ModifyImageName = {
    basePath: KecPath,
    params: {
        Action: 'ModifyImageName',
        Service,
        Version,
        source
    }
};

export const RemoveImages = {
    method: 'post',
    basePath: KecPath,
    params: {
        Action: 'RemoveImages',
        Service,
        Version,
        source
    }
};

export const CheckHasIamRole = {
    method: 'post',
    basePath: KecPath,
    params: {
        Action: 'CheckHasIamRole',
        Service: 'iam',
        Version: '2015-11-01',
        source,
    }
};

export const imagePlatforms = {
    method: 'post',
    basePath: KecPath,
    params: {
        Action: 'ImportImagePlatforms',
        Service,
        Version,
        source,
    }
};

export const validateImportimg = {
    method: 'post',
    basePath: KecPath,
    params: {
        Action: 'ValidateImportImage',
        Service,
        Version,
        source,
    }
};

export const importImages = {
    method: 'post',
    basePath: KecPath,
    params: {
        Action: 'ImportImage',
        Service,
        Version,
        source,
    }
};


export const getQutainfos = {
    method: 'post',
    basePath: KecPath,
    params: {
        Action: 'DescribeQuotaInfoByQuotaName',
        Service,
        Version,
        source,
    }
};


export const copyImages = {
    method: 'post',
    basePath: KecPath,
    params: {
        Action: 'CopyImage',
        Service,
        Version,
        source,
    }
};

export const switchImageType = {
    method: 'post',
    basePath: KecPath,
    params: {
        Action: 'SwitchImageType',
        Service,
        Version,
        source,
    }
};

export const getcopyRegions = {
    method: 'post',
    basePath: KecPath,
    params: {
        Action: 'DescribeImageCopyRegions',
        Service,
        Version,
        source,
    }
};

export const getshareAccounts = {
    method: 'get',
    basePath: KecPath,
    params: {
        Action: 'DescribeImageSharePermission',
        Service,
        Version,
        source,
    }
};

export const shareImages = {
    method: 'post',
    basePath: KecPath,
    params: {
        Action: 'ModifyImageSharePermission',
        Service,
        Version,
        source,
    }
};

export const warmUpCustomImage = {
    method: 'post',
    basePath: KecPath,
    params: {
        Action: 'WarmUpCustomImage',
        Service,
        Version,
        source,
    }
};

export const cancelWarmUpCustomImage = {
    method: 'post',
    basePath: KecPath,
    params: {
        Action: 'CancelWarmUpCustomImage',
        Service,
        Version,
        source,
    }
};

export const DescribeImagesByTagValue = {
    basePath: KecPath,
    params: {
        Action: 'DescribeImagesByTagValue',
        Version,
        source,
        Service: 'tag',
        MaxResults: 1000,
        NextToken: ""
    },
    method: 'get'
};
export const DescribeLocalImageQuotaAndCount = {
    method: 'post',
    basePath: KecPath,
    params: {
        Action: 'DescribeLocalImageQuotaAndCount',
        Service,
        Version,
        source,
    }
};
export const QueryWhiteList = {
    basePath: KecPath,
    params: {
        Action: 'QueryWhiteList',
        Service,
        Version,
        source
    }
};
export const QueryBuckets = {
    basePath: KecPath,
    params: {
        Action: 'QueryBuckets',
        Service,
        Version,
        source
    }
};
export const ExportImage = {
    basePath: KecPath,
    params: {
        Action: 'ExportImage',
        Service,
        Version,
        source
    }
};
export const CancelImageExport = {
    basePath: KecPath,
    params: {
        Action: 'CancelImageExport',
        Service,
        Version,
        source
    }
};
export const DescribeKs3ServiceStatus = {
    method: 'post',
    basePath: KecPath,
    params: {
        Action: 'DescribeKs3ServiceStatus',
        Service,
        Version: '2016-03-04',
        source,
    }
};

export const ImageAccelerate = {
    method: 'post',
    basePath: KecPath,
    params: {
        Action: 'ImageAccelerate',
        Service,
        Version: '2016-03-04',
        source,
    }
};
export const IsUserSupportImageAccelerate = {
    method: 'post',
    basePath: KecPath,
    params: {
        Action: 'IsUserSupportImageAccelerate',
        Service,
        Version: '2016-03-04',
        source,
    }
};
export const ModifyImageAttribute = {
    method: 'post',
    basePath: KecPath,
    params: {
        Action: 'ModifyImageAttribute',
        Service,
        Version: '2016-03-04',
        source,
    }
};